import moment from "moment";

const transformData = data => {
  return {
    canNumber: data.canNumber || '',
    activityCode: data.eventID || '',
    qrCodeID: data.qrCodeID || '',
    eventID: data.eventID || '',
    transactionDateTime: moment().format('yyyy-MM-DDHH:mm:ss'),
    activityName: data.title || '',
    orgCommitteeCode: data.organizationName,
    address: data.address || '',
    customerID: data.customerId || '',
    userInput: data.input || '',
    userInputType: data.inputType || '',
    dob: data.dob || '',
    card: data.card || {},
    cardType: data.cardType || '',
    idType: data.idType || '',
    mobile: data.mobile || '',
    consent: data.consent || {},
    memberName: data.name || '',
    entryMode:'EMS',
    // memberType: data.memberType || '',
    phone: data.phone || '',
    sessionID: data.sessionID,
    PAuid: data.PAuid || ''
  };
};

export default transformData;